import styled from 'styled-components'

export const FooterContainer = styled.div`
  margin: 0 auto;
  padding: 2rem 0 4rem 0;
  margin-top: 148px;
  background-color: #21105d;

  button {
    background: none;
  }

  button,
  a {
    &.social-link {
      filter: brightness(0) saturate(100%) invert(95%) sepia(1%) saturate(2203%)
        hue-rotate(185deg) brightness(105%) contrast(97%);

      &:not(:last-child) {
        margin-right: 1rem;
      }
    }
  }

  .menu-flags {
    padding: 0;
    font-size: 16px;

    span {
      padding: 0;
      font-weight: 500;
    }

    svg {
      display: none;
    }

    li {
      color: #f8f9fd;

      & span {
        font-weight: 400;
      }
    }
  }

  .menu-flags-button {
    display: flex;
    border: 1px solid #f8f9fd;
    color: #f8f9fd;
    width: auto;
    margin-bottom: 0 !important;
  }

  #rfs-btn::after {
    margin-left: 2rem;
    border-top-color: #f8f9fd !important;
    border-bottom-color: #f8f9fd !important;
  }

  .menu-flags ul {
    background-color: #21105d !important;
    border: 1px solid #3d2db3 !important;

    li {
      color: #f8f9fd !important;

      &:hover {
        background-color: #3d2db3 !important;
      }
    }
  }

  @media (max-width: 900px) {
    padding-top: 5rem;
  }
`

export const NavMenu = styled.div`
  display: flex;
  align-items: center;
  border-bottom: 1px solid var(--grey3);
  margin-bottom: 1.5rem;
  width: 100%;
  justify-content: space-between;

  button,
  a {
    font-size: 16px;
    font-weight: 700;
    color: #f8f9fd;
  }

  div:not(#button-menu) {
    margin-bottom: 1rem;
  }

  div#button-menu {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 50px;

    @media only screen and (min-width: 1337px) {
      > * {
        flex: 0 0 115px;
      }
    }
  }

  @media only screen and (max-width: 1050px) {
    justify-content: space-between;
    margin-bottom: 2rem;

    div:not(#button-menu) {
      margin-right: 0;
      margin-bottom: 1rem;
    }

    div#button-menu {
      position: relative;
      left: 0 !important;
      margin-bottom: 0.5rem;
    }

    button,
    a {
      &:not(:last-child) {
        margin-right: 4rem;
      }
    }
  }

  @media only screen and (max-width: 900px) {
    div#button-menu {
      display: none;
    }
  }
`

export const AppContainer = styled.div`
  display: flex;
  align-items: center;

  img {
    width: 150px;
    height: 100%;
    height: 50px;

    &:first-child {
      margin-right: 1rem;
    }
  }
`

export const LinkMenu = styled.div`
  display: flex;
  justify-content: flex-start;
  gap: 50px;

  @media only screen and (min-width: 1337px) {
    > * {
      flex: 0 0 115px;
    }
  }

  > div.last-only {
    @media only screen and (min-width: 1337px) {
      flex: 0 0 332px;
    }
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-left: 25px;

    @media only screen and (max-width: 700px) {
      display: block;
    }

    p,
    a {
      text-align: center;
    }
  }

  p {
    margin-bottom: 1.25rem;
    font-weight: 600;
    color: #f8f9fd;
  }

  button,
  a {
    display: block;
    font-size: 16px;
    color: #f8f9fd;
    white-space: pre-line;

    &:not(:last-child) {
      &:not(.social-link) {
        margin-bottom: 2rem;
      }
    }

    &.hover:hover > span:not(.material-icons-round) {
      text-decoration: underline;
    }
  }

  .joined-col {
    display: none;

    & > *:not(:last-child) {
      margin-bottom: 2rem;
    }
  }

  @media only screen and (max-width: 1050px) {
    .joined-col {
      display: block;
    }

    .desktop-only {
      display: none;
    }
  }

  @media only screen and (max-width: 700px) {
    display: block;
    margin-top: 4rem;

    & > *:not(:last-child),
    .joined-col > *:not(:last-child) {
      margin-bottom: 4rem;
    }
  }
`

export const ContactsMenu = styled.div`
  button,
  a {
    display: flex;
    align-items: center;
    margin-bottom: 1.5rem !important;

    & > *:first-child {
      margin-right: 0.5rem;
    }
  }

  img {
    width: 24px;
    filter: brightness(0) saturate(100%) invert(95%) sepia(1%) saturate(2203%)
      hue-rotate(185deg) brightness(105%) contrast(97%);
  }
`

export const MobileSocialLinks = styled.div`
  display: none;
  margin-top: 6rem;

  & > *:first-child {
    margin-right: 3rem;
  }

  @media only screen and (max-width: 1050px) {
    display: flex;
  }
`

export const Copyright = styled.div`
  margin: 0 auto;
  padding: 6rem 0 0;
  text-align: center;
  color: #f8f9fd;

  .mobile-only {
    display: none;

    & > *:first-child {
      margin-bottom: 1rem;
    }
  }

  @media only screen and (max-width: 700px) {
    .desktop-only {
      display: none;
    }

    .mobile-only {
      display: block;
    }
  }
`
